namespace GeniuzPOS.Common.Report {
    export interface FilterHeader extends Serenity.ListRequest {
        Para?: Lookups.VwPsParaRow;
        URLpic?: string;
        BizName?: string;
        Shop?: string;
        DatetoDate?: string;
        Supdata?: string;
        fillterline1?: string;
        fillterline2?: string;
        fillterline3?: string;
        user?: string;
    }
}
